import React from 'react'
import Confirm from 'views/confirm/confirm'
import { connect } from 'react-redux'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'

import myLibraryActions from 'redux/actions/my_library_actions'
import { localize } from 'helpers/translator'

const MyLibraryPlatinumDowngrade = props => (
	<Confirm
		alertTitle={localize('login_notification_downgrade_platinum_to_gold_title')}
		btTwo={localize('login_notification_downgrade_platinum_to_gold_buton')}
		alertMessage={localize('login_notification_downgrade_platinum_to_gold_message')}
		actionTwo={props.actions.closePlatinumDowngradeAccount}
		closeAction={props.actions.closePlatinumDowngradeAccount}
	/>
)

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		closePlatinumDowngradeAccount: myLibraryActions.closePlatinumDowngradeAccount,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(MyLibraryPlatinumDowngrade)

export { MyLibraryPlatinumDowngrade }
